import React, { useState } from 'react';
import { StatOptions } from 'fs';
import {AutocompleteData} from '../models/Site'
import './_IDNameDescriptionItemSelect.css'


export type Option ={
  Value:string,
  Text:string,
 
}

type Props = {
    Value:any|null,
    Id:string,
    OnChange?:any,
    OnSelect?:any|undefined,
    OnBlur?:any|undefined;
    OnFocus?:any|undefined;
    ClassName:string,
    DataList:Array<AutocompleteData>,
    simulatorData?:any,
    Disabled?:boolean,
    // dilay?:number,
  };

  type State = {
    isOptionOpen:boolean,
    Value:any|null,
  };
  

export class Autocomplete extends React.Component<Props,State>
{
    constructor(props:any) {
      super(props); 
      this.state = {isOptionOpen:false, Value: this.props.Value}
      this.handleChange.bind(this);
      this.handleSelect.bind(this);
    }

    componentDidMount () {
      
    }

    handleFocus = (event:any) => {
      //console.log('list', this.props.DataList);
      this.setState({ 
        isOptionOpen: true
      });
      if(this.props.OnFocus!=null){
        this.props.OnFocus();  
      }
    }

    handleChange = (event:any) => {
      var value= event.currentTarget.value;
      this.setState({
        isOptionOpen: true,
        Value:value
      });

      if(this.props.OnChange!=null){
        this.props.OnChange(value);  
      }
    }

    handleBlur = (event:any) => {
      if(this.props.OnBlur!=null){
        var value= event.currentTarget.value;      
        this.props.OnBlur(value); 
      }

      const that = this;

      // let delayNumber = this.props.dilay ? this.props.dilay : 500;
      setTimeout(()=>{
        that.setState({
          isOptionOpen: false
        });
      }, 500);
      
    }

    handleSelect = (item: any) => {
      //console.log('Autoselect handleSelect', this.props, item);
      // 
      this.props.OnSelect(item.val ? item.val : item.value);  
      this.setState({
        isOptionOpen: false
      });
    }

    handleDelete=(e:any)=>{
      //console.log('Autoselect handleDelete', this.props, e);
      e.currentTarget.id = undefined;
      e.currentTarget.innerHTML = "";
      this.handleChange(e);
      this.props.OnSelect("");  
      this.setState({
        isOptionOpen: false,
        Value: ''
      });
      
    }

      
    render() {
      return ( 
        <div className='autocompleteDiv'>
          <input type="text" value={ this.props.Value } id={this.props.Id} 
            onChange={(e:any)=>this.handleChange(e)} 
            onBlur={(e:any)=>this.handleBlur(e)}
            onFocus={(e:any)=>this.handleFocus(e)}
            autoComplete="off"
            disabled={this.props.simulatorData && this.props.simulatorData != null || this.props.Disabled} />
          <div className={
            (
              this.state.isOptionOpen != null && this.state.isOptionOpen == true 
            ) || (
              this.state.Value == '' || this.state.Value == null || this.state.Value.length==0
            ) ? 'hide':'deleteIcon' }
            onClick={(e:any) =>this.handleDelete(e)}
          ></div>
          <div className={this.state.isOptionOpen != null && this.state.isOptionOpen == true ? 'autocompleteList' : 'hide'}>
            <>
              {this.props.DataList!=null? this.props.DataList.map(
                (item: any, index: number) => {
                  return <div
                    className='autocompleteItem'
                    onClick={(e:any) =>  this.handleSelect(item)}
                    id={item.val ? item.val : item.value}
                    key={index}
                  >
                    {item.label ? item.label : item.text}
                  </div>
                }) : ""
              }
            </>
        
          </div>
        </div>  
          
        
      );
    }
  }
